import { render } from "./BaseTableProcedureResults.vue?vue&type=template&id=87fb24a2&scoped=true"
import script from "./BaseTableProcedureResults.vue?vue&type=script&lang=js"
export * from "./BaseTableProcedureResults.vue?vue&type=script&lang=js"

import "./BaseTableProcedureResults.vue?vue&type=style&index=0&id=87fb24a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87fb24a2"]])

export default __exports__